import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPostidentStepThree = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 49,
	height: 42,
	viewBox: "0 0 49 42",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M24.702 31.7982L2.73359 19.7125C3.203 19.2043 3.84958 18.5117 4.63093 17.6928C6.32516 15.9171 8.64875 13.5526 11.1713 11.1906C13.6982 8.82471 16.4042 6.48074 18.8656 4.73454C20.0967 3.86116 21.2457 3.15236 22.2647 2.66541C23.3005 2.17043 24.1191 1.94542 24.7127 1.94542C25.3116 1.94542 26.1311 2.16607 27.1623 2.64769C28.1776 3.12187 29.3208 3.81193 30.5446 4.66207C32.9916 6.3619 35.6786 8.6437 38.1864 10.9471C40.69 13.2466 42.9947 15.5486 44.6748 17.2773C45.4456 18.0705 46.0841 18.7421 46.5488 19.236L24.702 31.7982Z",
			fill: "white",
			stroke: "#4EA699",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 12,
			y: 5.00012,
			width: 26,
			height: 33,
			fill: "white",
			stroke: "#4EA699",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M47 40.5001H1.5V22.5001L14 28.9854L16.5 27.0001H32L35 29.3144L47 22.5001V40.5001Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.5 40.5001H47M1.5 40.5001V22.5001L14 28.9854M1.5 40.5001L14 28.9854M47 40.5001V22.5001L35 29.3144M47 40.5001L35 29.3144M14 28.9854L16.5 27.0001H32L35 29.3144",
			stroke: "#4EA699",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 16,
			y1: 10.5001,
			x2: 34,
			y2: 10.5001,
			stroke: "#4EA699"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 16,
			y1: 13.5001,
			x2: 34,
			y2: 13.5001,
			stroke: "#4EA699"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 16,
			y1: 16.5001,
			x2: 34,
			y2: 16.5001,
			stroke: "#4EA699"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 16,
			y1: 19.5001,
			x2: 34,
			y2: 19.5001,
			stroke: "#4EA699"
		})
	]
});
const ForwardRef = forwardRef(SvgPostidentStepThree);
export { ForwardRef as ReactComponent };
